import { render, staticRenderFns } from "./switcher.vue?vue&type=template&id=b7f55402&scoped=true&"
import script from "./switcher.vue?vue&type=script&lang=js&"
export * from "./switcher.vue?vue&type=script&lang=js&"
import style0 from "./switcher.vue?vue&type=style&index=0&id=b7f55402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f55402",
  null
  
)

export default component.exports